import React, { Component } from 'react'
import './css.css';
import Web3 from 'web3';
import utils from '../../library'
import ShopToken from '../Ticket1_0/ShopToken'
import FreeToken from '../Freebies1_0/FreeToken'
import ShopPair from '../PairSwapper1_0/ShopPair'
import ShopHeader from '../ShopHeader/ShopHeader'
import GhostContainer from '../GhostContainer/GhostContainer';

class Favorites extends Component {
constructor(){
  super()
  this.reload = this.reload.bind(this);
  this.state={show:"products",favoriteProducts:[],favoriteShops:[],ghostFavorite:[],reload: () => this.reload()}
  
}

    async componentDidMount(){
        if(this.state.show=="products")await this.loadFaves()
        if(this.state.show=="shops")await this.loadShops()
        this.loadGhosts()
    }

    reload(){
      if(this.state.show=="products")this.loadFaves()
      if(this.state.show=="shops")this.loadShops()
      this.loadGhosts()
    }

async loadFaves(){
    
        
    
    let final=[]
    let s=utils.getCookie("favorite")
    let reload=() => this.reload()
    let arr=s.split(",")
    let prp=this.props
    let stt=this.state
    await window.ethereum.enable().then(async function (accounts) { 
     
    for(let i=0;i<arr.length;i++){
      
      if(arr[i]!=""){
        
        let token=arr[i].substr(0,arr[i].indexOf("_"))
        
        let list=arr[i].substr(arr[i].indexOf("_")+1,42)
        if(token!="undefined"){
          if(list!="undefined"){
        let index=arr[i].substr(arr[i].lastIndexOf("x")+1,arr[i].length)
        const { REACT_APP_TICKETABI } = process.env;
        
        const tickC = new web3.eth.Contract(JSON.parse(REACT_APP_TICKETABI), list)
         
        let priceList = await tickC.methods.prices().call()
        
        let code = await tickC.methods.code().call()
        
        const { REACT_APP_PriceListABI } = process.env;
        const priceListC = new web3.eth.Contract(JSON.parse(REACT_APP_PriceListABI), priceList) 
        let price = await priceListC.methods.price(token).call()
        if((code==4)||(code==7)||(code==9))
        final.push(<GhostContainer ghost={false} reload={() => reload()} ticketCode={code} db={prp.db} priceList={list} address={token} price={price} index={list+"x"+index} ticket={list} key={i} edit={""} name={"nnn"}></GhostContainer>)
        }}
      }
    }

  })
  this.setState({favoriteProducts:final})
}

async loadGhosts(){

  let final=[]
  let s=utils.getCookie("ghost")

  let arr=s.split(",")
  let prp=this.props
  let stt=this.state
  let reload=() => this.reload()
  await window.ethereum.enable()
   
  for(let i=0;i<arr.length;i++){
    
    if(arr[i]!=""){
      
      let token=arr[i].substr(0,arr[i].indexOf("_"))
      
      let list=arr[i].substr(arr[i].indexOf("_")+1,42)
      if(token!="undefined"){
        if(list!="undefined"){
      let index=arr[i].substr(arr[i].lastIndexOf("x")+1,arr[i].length)
      const { REACT_APP_TICKETABI } = process.env;
      
      const tickC = new web3.eth.Contract(JSON.parse(REACT_APP_TICKETABI), list)
       
      let priceList = await tickC.methods.prices().call()
      
      let code = await tickC.methods.code().call()
      
      const { REACT_APP_PriceListABI } = process.env;
      const priceListC = new web3.eth.Contract(JSON.parse(REACT_APP_PriceListABI), priceList) 
      let price = await priceListC.methods.price(token).call()
      if((code==4)||(code==7)||(code==9))
      final.push(<GhostContainer ghost={true} reload={() => reload()} ticketCode={code} db={prp.db} priceList={list} address={token} price={price} index={list+"xy"+index} ticket={list} key={i} edit={""} name={"nnn"}></GhostContainer>)
      }}
    }
  }


this.setState({ghostFavorite:final})
}

async seeGhost(){
  let t=utils.getCookie("ghost")
  let arr=t.split(",")
  t=""
  for(let i=1;i<arr.length;i++){
    t+=arr[i].substring(arr[i].indexOf("_")+1,arr[i].length)
    if(i<arr.length-1)t+=","
  }
  let name=document.getElementById("Shop_meta_setname").value
  let desc=document.getElementById("Shop_meta_setdesc").value
  let dark=document.getElementById("Shop_meta_setdark").value
  let light=document.getElementById("Shop_meta_setlight").value
  let text=document.getElementById("Shop_meta_settext").value
  await window.ethereum.enable().then(async function (accounts) { 
    let tt=utils.toHex(t+"xxx"+accounts[0])
    let url="/smartshop/?ghost="+tt+"&dark="+dark+"&light="+light+"&text="+text+"&name="+name+"&description="+desc
    window.open(url)
  })
}

async loadShops(){
  let final=[]
  let s=utils.getCookie("favoriteShop")

  let arr=s.split(",")
  let rel=() => this.reload()
  await window.ethereum.enable().then(async function (accounts) { 
   
  for(let i=0;i<arr.length;i++){
    
    if(arr[i]!=""){
      
      let ticket=arr[i].substr(0,arr[i].indexOf("_"))
      if(ticket!="undefined"){
      const { REACT_APP_TICKETABI } = process.env;    
      const tickC = new web3.eth.Contract(JSON.parse(REACT_APP_TICKETABI), ticket)
      
      let code = await tickC.methods.code().call()
      
      final.push(<ShopHeader  reload={rel} ticket={ticket} key={i} index={i}></ShopHeader>);
      }
    }

  }

})
this.setState({favoriteShops:final})
}

    deleteFavorites(what){
       if(what=="shops"){
        document.cookie = "favoriteShop=aaa; expires=Fri, 27 Jul 2001 02:47:11 UTC; path=/";
        document.cookie = "favoriteShop=aaa; expires=Fri, 27 Jul 2001 02:47:11 UTC; path=/smartshop/";  
        document.cookie = "favoriteShop=aaa; expires=Fri, 27 Jul 2001 02:47:11 UTC;"; 
       }
       if(what=="products"){
        document.cookie = "favorite=aaa; expires=Fri, 27 Jul 2001 02:47:11 UTC; path=/"; 
        document.cookie = "favorite=aaa; expires=Fri, 27 Jul 2001 02:47:11 UTC; path=/smartshop/"; 
        document.cookie = "favorite=aaa; expires=Fri, 27 Jul 2001 02:47:11 UTC;"; 
        }
        if(what=="ghost"){
          document.cookie = "ghost=aaa; expires=Fri, 27 Jul 2001 02:47:11 UTC; path=/"; 
          document.cookie = "ghost=aaa; expires=Fri, 27 Jul 2001 02:47:11 UTC; path=/smartshop/"; 
          document.cookie = "ghost=aaa; expires=Fri, 27 Jul 2001 02:47:11 UTC;"; 
          }
        this.loadFaves()
        this.loadShops()
        this.loadGhosts()
   
    }
   
    
    getCookie(cname) {
        var name = cname + "=";
     
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }

      toggle(what){
       this.setState({show:what})
      if(what=="products")this.loadFaves()
      if(what=="shops")this.loadShops()
      }
   
    render(){
        console.log(this.props.update) 
        return ( 
        <div>

        <div id="faves_flyer"><div id="favorites_mainlabel">favorites</div>
            <div id="favorites_image"  alt="favorites">⭐️</div>
            <div id="favorites_sublabel">favorite products list</div>
            <div id="faves_upper_part">
            <div className="faves_menu_panel">
              <div id="faves_menu_shops" className={"faves_menu_icon "+((this.state.show=="shops")?"selected dark darkblue":"dhover darkhover")} onClick={() => this.toggle("shops")}>❤️</div> 
              <div id="faves_menu_products" className={"faves_menu_icon "+((this.state.show=="products")?"selected dark darkblue":"dhover darkhover")} onClick={() => this.toggle("products")}>⭐️</div> 
            </div> 
      {(this.state.show=="products")?
        <div className="faves_panel">{this.state.favoriteProducts}</div>
        :<></>
      }
        {(this.state.show=="shops")?
        <div className="faves_panel">{this.state.favoriteShops}</div>
        :<></>
        }
        <div className="faves_menu_panel">
        {(this.state.show=="shops")?<input className="delete_button dark darkblue text white" type="button" value="✂️❤️" onClick={() => this.deleteFavorites("shops")}></input>:<></>}
        {(this.state.show=="products")?<input className="delete_button dark darkblue text white" type="button" value="✂️⭐️" onClick={() => this.deleteFavorites("products")}></input>:<></>}
      </div>
      <div className="clear"></div>
      </div>
      {(this.state.show=="products")?
      <>
        {(this.state.ghostFavorite.length>0)?
        <>
          <div className="faves_ghost_label dark darkblue text white">👻 GhostShop</div>
          <div className="faves_ghost_panel">{this.state.ghostFavorite}</div>
        </>
        :<div className="faves_ghost_label dark darkblue text white">👻 GhostShop EMPTY</div>
        }
      <div className="faves_menu_panel">
        <input className="delete_button dark darkblue text white" type="button" value="✂️👻" onClick={() => this.deleteFavorites("ghost")}></input>
        <input className="openghost_button dark darkblue text white" type="button" value="see ghost 👁️" onClick={() => this.seeGhost()}></input>
        </div>
        <div className="Ghost_meta_panel dark darkblue text white">
          <div>
            <span>🛒 GhostShop name:</span><br></br>
            <input id="Shop_meta_setname" className="Shop_meta_setval light lightblue" type="text" ></input>
          </div>
          <div>
            <span>🏷️ description:</span><br></br>
            <input id="Shop_meta_setdesc" className="Shop_meta_setval light lightblue" type="text" ></input>
          </div>
          <div>
            <span>🎨 colors (dark and light and text):</span><br></br>
            <div className="metacontent_left">#</div>
            <input id="Shop_meta_setdark" className="Shop_meta_setval_color light lightblue" type="text" ></input>
            <div className="metacontent_right">#</div>
            <input id="Shop_meta_setlight" className="Shop_meta_setval_color light lightblue" type="text" ></input>
            <div className="metacontent_right">#</div>
            <input id="Shop_meta_settext" className="Shop_meta_setval_color light lightblue" type="text" ></input> 
            <div className="clear"></div>
          </div>
        </div>
      </>
      :<></>
    }
      
      </div>
        </div>
        );
    }


}


const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")

export default Favorites